module.exports = __webpack_public_path__ + "img/DBV_logo-02.e359f311.png";